<header
  class="app-header"
  [class.app-header--nav-collapsed]="navCollapsed()"
  [class.app-header--nav-measuring]="!navMeasured()"
>
  <div class="app-header__inner" #inner>
    <!-- Logo -->
    <a class="app-header__logo" routerLink="/" aria-label="Gå til forsiden">
      @if (site.settings()?.logo) {
        <img [src]="site.settings()!.logo" alt="Logo" class="app-header__logo-img" />
      } @else {
        <span class="app-header__logo-text">{{ site.settings()?.name ?? 'Aktiv By' }}</span>
      }
    </a>

    <!-- Primary navigation: desktop only, and only while it fits -->
    <nav class="app-header__nav" aria-label="Primær navigation" #nav>
      @for (item of site.navItems(); track item.id) {
        <a
          matButton
          [routerLink]="item.path"
          routerLinkActive="--active"
          class="app-header__nav-link"
          >{{ item.title }}</a
        >
      }
    </nav>

    <!-- Actions: cart + auth + Foreningsportal -->
    <div class="app-header__actions">
      @if (site.showBookingModule()) {
        <app-basket-button />
      }

      @if (site.showAccountModule()) {
        <!-- Separates the basket button from the auth entries, so it needs both to be there. -->
        @if (site.showBookingModule()) {
          <div class="app-header__divider app-header__divider--desktop" aria-hidden="true"></div>
        }

        <div class="app-header__auth app-header__auth--desktop">
          @if (auth.isAuthenticated()) {
            <abook-button [menu]="accountMenu" appearance="filled" size="medium" icon="person">{{
              displayName()
            }}</abook-button>
            <mat-menu #accountMenu>
              <a mat-menu-item routerLink="/account/profile"><mat-icon>person</mat-icon>Min side</a>
              <button mat-menu-item (click)="auth.signOut()">
                <mat-icon>logout</mat-icon>Log ud
              </button>
            </mat-menu>
          } @else {
            <button matButton (click)="signIn()" class="app-header__login-btn">Log ind</button>
            <abook-button
              link="/account/create"
              appearance="filled"
              size="medium"
              icon="person"
              >Ny bruger</abook-button
            >
          }
        </div>
      }

      <!-- Desktop only; the drawer carries it once the nav collapses. -->
      @if (site.associationPortalUrl(); as portalUrl) {
        @if (site.showBookingModule() || site.showAccountModule()) {
          <div class="app-header__divider app-header__divider--desktop" aria-hidden="true"></div>
        }
        <abook-button
          class="app-header__association-portal"
          [link]="portalUrl"
          target="_blank"
          appearance="filled"
          size="medium"
          icon="groups"
          >For foreninger<span class="sr-only"> (åbner i ny fane)</span></abook-button
        >
      }
    </div>

    <!-- Hamburger: mobile, or when the primary nav does not fit -->
    <button
      matIconButton
      class="app-header__hamburger"
      (click)="openMenu()"
      aria-label="Åbn navigation"
    >
      <mat-icon>menu</mat-icon>
    </button>
  </div>
</header>
